import apiClient from './apiClient';

// Get the base URL from environment variables
const AUTH0_API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

// Debug: Check what URL is being used
// console.log('AUTH0_API_BASE_URL from env:', AUTH0_API_BASE_URL);
// console.log('All env vars:', process.env);

// Note: HTTPS connectivity test removed to prevent unauthenticated API calls
// If you need to test connectivity, use the authenticated API functions instead

// Critical check: Ensure the URL was actually baked in during build
if (!AUTH0_API_BASE_URL) {
  console.error('CRITICAL ERROR: REACT_APP_BACKEND_URL is not defined in the build. Check your build pipeline and Dockerfile.');
  // you might want to throw an Error.
} else {
  // console.log('Using Auth0 API Base URL (from build-time env):', AUTH0_API_BASE_URL); // For debugging
}

export const createUser = async (data) => {
  // Fallback to a non-functional string if the base URL isn't set, to prevent crashes on undefined
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.post(`${baseUrl}/api/auth0/create-user`, data);
};

export const fetchRoles = async (getToken = null) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';

  const headers = {
    'Content-Type': 'application/json'
  };

  // Add authentication if token getter is provided
  if (typeof getToken === 'function') {
    try {
      const token = await getToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (tokenError) {
      console.warn('Failed to get authentication token for roles:', tokenError);
    }
  }

  const res = await apiClient.get(`${baseUrl}/api/auth0/roles`, { headers });
  return res.data;
};

export const assignUserRole = async (userId, roleId) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.post(`${baseUrl}/api/auth0/assign-role`, { userId, roleId });
};

export const fetchOrganizations = async (getToken = null) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';

  const headers = {
    'Content-Type': 'application/json'
  };

  // Add authentication if token getter is provided
  if (typeof getToken === 'function') {
    try {
      const token = await getToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (tokenError) {
      console.warn('Failed to get authentication token for organizations:', tokenError);
    }
  }

  const res = await apiClient.get(`${baseUrl}/api/auth0/organizations`, { headers });
  return res.data;
};

export const addUserToOrganization = async (userId, organizationId) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.post(`${baseUrl}/api/auth0/add-to-org`, { userId, organizationId });
};

export const fetchOrgMembers = async (orgId, getToken = null) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';

  const headers = {
    'Content-Type': 'application/json'
  };

  // Add authentication if token getter is provided
  if (typeof getToken === 'function') {
    try {
      const token = await getToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    } catch (tokenError) {
      console.warn('Failed to get authentication token for org members:', tokenError);
    }
  }

  const res = await apiClient.get(`${baseUrl}/api/auth0/org-members/${orgId}`, { headers });
  return res.data;
};

export const updateUser = async (userId, data) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.patch(`${baseUrl}/api/auth0/update-user/${userId}`, data);
};

export const updateUserRole = async (userId, roleId) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.post(`${baseUrl}/api/auth0/update-user-role/${userId}`, { roleId });
};

export const deleteUser = async (userId) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.delete(`${baseUrl}/api/auth0/delete-user/${userId}`);
};

export const updateUserOrgRole = async (userId, organizationId, roleId) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.post(`${baseUrl}/api/auth0/update-user-org-role/${userId}`, { organizationId, roleId });
};

export const getUserMfaEnrollments = async (userId) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.get(`${baseUrl}/api/auth0/user-mfa-enrollments/${userId}`);
};

export const createMfaChallenge = async (userId, challengeType = 'otp') => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.post(`${baseUrl}/api/auth0/create-mfa-challenge/${userId}`, { challengeType });
};

export const deleteMfaEnrollment = async (userId, enrollmentId) => {
  const baseUrl = AUTH0_API_BASE_URL || 'https://auth0-api-url-not-set.invalid';
  return apiClient.delete(`${baseUrl}/api/auth0/delete-mfa-enrollment/${userId}/${enrollmentId}`);
};